module.exports = __webpack_public_path__ + "static/olimpia-20248a346072482859a4c0a868a3d5d6.png";